import { Expose, Type, plainToInstance } from "class-transformer";
import {
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsDate,
} from "class-validator";

export enum ProductType {
  PACKAGE = "PACKAGE",
  ADD_ON = "ADD_ON",
  UPGRADE = "UPGRADE",
  ADDITIONAL_REVISION = "ADDITIONAL_REVISION",
}

export enum PackageType {
  FRONT_YARD = "FRONT_YARD",
  BACK_YARD = "BACK_YARD",
  FULL_YARD = "FULL_YARD",
  UBER_PREMIUM = "UBER_PREMIUM",
  BOTANICAL = "BOTANICAL",
  CURB_APPEAL = "CURB_APPEAL",
  WHOLE_HOME = "WHOLE_HOME",
}

export enum AddOnType {
  EXTERIOR = "EXTERIOR",
  EXPEDITED = "EXPEDITED",
  HOA = "HOA",
}

export enum LotSize {
  STANDARD = "STANDARD",
  LARGE = "LARGE",
}

export class Product {
  public static from(product: Product) {
    return plainToInstance(Product, product, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  sku!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  name!: string;

  @Expose()
  @IsEnum(ProductType)
  productType!: ProductType;

  @Expose()
  @IsOptional()
  @IsEnum(PackageType)
  packageType?: PackageType;

  @Expose()
  @IsOptional()
  @IsEnum(AddOnType)
  addOnType?: AddOnType;

  @Expose()
  @IsOptional()
  @IsEnum(LotSize)
  lotSize?: LotSize;

  @Expose()
  @IsOptional()
  @IsString()
  designProjectId?: string;

  @Expose()
  @IsInt()
  price!: number;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;
}
